import React, { useState } from 'react';
import { RenewalData, withRenewalContext } from '../../context/RenewalProvider';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import RenewalActions from '../policy/Actions/RenewalActions';
import Breadcrumbs from '../policy/Renewals/Breadcrumbs';
import RenewalOverview from '../policy/Renewals/Overview';

interface Props {
	children?: JSX.Element | JSX.Element[];
	renewalData: RenewalData;
}

const RenewalLayout = (props: Props) => {
	const [loading, setLoading] = useState<boolean>(false);
	props.renewalData.setLoading = setLoading;

	const renderActions = () => {
		return <RenewalActions />;
	};

	return (
		<>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				{renderActions()}
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<RenewalOverview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withRenewalContext<Props>(RenewalLayout);
